import React from 'react';
import PropTypes from 'prop-types';
import {Drawer} from '@learningblocks/exp-components';
import {NotebookSections} from './NotebookSections';
import {NotebookSectionsHeader} from './NotebookSectionsHeader';
import {NotebookSectionsList} from './NotebookSectionsList';
import {NotebookContent} from '../NotebookContent';
import {ProtocolOptions} from '../ProtocolOptions';
import {NOTEBOOK_SECTIONS} from '@learningblocks/protocol-constants/lib/Utilities';
import './style.scss';

export class Notebook extends React.Component {

  getLevelString = (id) => {

    let dict = {
      1: "one",
      2: "two",
      3: "three"
    }

    return "Level "+dict[id];
  }

  renderProtocolContent = () => {
    return (
      <>
        <NotebookSections>
          <NotebookSectionsHeader level={this.getLevelString(this.props.levelSelected.id)} />
          <ProtocolOptions />
        </NotebookSections>
      </>
    );
  };
  renderSectionContent = () => {
    return (
      <>
        <NotebookContent />
        <NotebookSections>
          <NotebookSectionsHeader level={this.getLevelString(this.props.levelSelected.id)} />
          <NotebookSectionsList />
        </NotebookSections>
      </>
    );
  };
  renderByProps = () => {
    if (this.props.currentSectionType === NOTEBOOK_SECTIONS.PROTOCOL) {
      return this.renderProtocolContent();
    } else {
      return this.renderSectionContent();
    }
  };

  componentDidMount(){
    document.body.classList.remove('sidebar-collapsed');
    document.body.classList.add('sidebar-expanded');
  }
  
  render() {
    return (
      <Drawer expanded={(this.props.currentSectionType !== NOTEBOOK_SECTIONS.PROTOCOL)}>
        <div className='notebook'>{this.renderByProps()}</div>
      </Drawer>
    );
  }
}
Notebook.propTypes = {
  currentSectionType: PropTypes.string,
};
